<div class="link-account-dialog-container">
  <div class="link-account-dialog-header">
    <button
      class="link-account-dialog-close-button focus-link"
      type="button"
      (click)="dismissLinkAccountDialog()"
      [attr.aria-label]="'modal.close' | translate">
      <rd-shared-icon
        [class]="'icon-' + closeIcon"
        [iconSymbol]="'icon-' + closeIcon"
        tabindex="-1">
      </rd-shared-icon>
    </button>
  </div>

  <div class="link-account-dialog-content">
    <h1 class="link-account-dialog-title">
      {{
        'transfer_v2.link_account_dialog.title'
          | translate
            : {
                loyaltyProgramShortName: this.loyaltyProgram.shortName
              }
      }}
    </h1>

    <p
      class="enrollment-text"
      *ngIf="
        loyaltyProgram.pointsTransferCapability.enrollmentUrl as enrollmentUrl
      ">
      <span class="enrollment-question">{{
        'transfer_v2.checkout.not_a_member' | translate
      }}</span>
      <rd-shared-link
        class="enrollment-url"
        [text]="'transfer_v2.checkout.join_now' | translate"
        [path]="enrollmentUrl.toString()"
        [isTargetBlank]="true">
      </rd-shared-link>
    </p>

    <rd-tcv2-link-account-form
      [user]="user"
      [disablePrefilledFields]="shouldDisablePrefilledLinkAccountFields"
      [formData]="membershipDetailFormData()"
      [loading]="createOrUpdateMembershipIsLoading$ | async"
      [loyaltyProgram]="loyaltyProgram"
      [prefillForm]="shouldPrefillLinkAccountForm"
      (submitForm)="linkAnAccount($event)">
    </rd-tcv2-link-account-form>
  </div>
</div>
